import { SensorType, SENSOR_TYPE_LIST } from '@innovyze/shared-utils';
import {
	ActionBar,
	ActionBarItemGroup,
	Button,
	DropdownSelect,
	rem,
	StylovyzeSearchBar,
	useIsFeatureEnabled,
} from '@innovyze/stylovyze';
import React from 'react';
import { useHistory } from 'react-router-dom';

import { useGlobalization } from '@Translations';
import { SENSOR_GROUP_ROUTES } from '@Types/routes';
import { SensorGroupsSearchProps } from '@Types/sensorGroup.types';
import { addRouteNamespace } from '@Utils/actions';
import { TSensorTypes } from '@Utils/valuemappingFormHelpers';

interface SensorGroupsTableHeaderProps {
	setSearchProps: React.Dispatch<
		React.SetStateAction<SensorGroupsSearchProps>
	>;
	searchProps: SensorGroupsSearchProps;
}

export default function SensorGroupsTableHeader({
	setSearchProps,
	searchProps,
}: SensorGroupsTableHeaderProps) {
	const { t } = useGlobalization();
	const multiTypeEnabled = useIsFeatureEnabled(
		'info-360-analytics-multi-type-sensor-group',
	);
	const history = useHistory();
	const options = [
		{
			key: 'All sensor types',
			value: 'All sensor types',
			label: t('All sensor types'),
		},
		...SENSOR_TYPE_LIST.map(item => ({
			key: item,
			value: item,
			label: TSensorTypes(t)[item],
		})),
	];

	if (multiTypeEnabled) {
		options.push({
			key: 'MultiType',
			value: 'MultiType',
			label: t('Multi-Type'),
		});
		options.sort((a, b) =>
			a.value > b.value ? 1 : b.value > a.value ? -1 : 0,
		);
	}

	return (
		<ActionBar>
			<ActionBarItemGroup columns={5}>
				<StylovyzeSearchBar
					dataCy="searchBarSensorGroup"
					label={t('Search')}
					placeholder={t('Search')}
					handleSearchSubmit={newValue =>
						setSearchProps(oldSearch => ({
							...oldSearch,
							searchQuery: newValue,
							offset: 0,
						}))
					}
				/>
				<DropdownSelect
					dataCy="sensorTypes"
					currentSelection={
						searchProps.sensorType || 'All sensor types'
					}
					title={t('Sensor Type')}
					options={options}
					onChange={e => {
						const sensorType = e.target.value;

						setSearchProps({
							...searchProps,
							offset: 0,
							sensorType:
								e.target.value === 'All sensor types'
									? undefined
									: (sensorType as SensorType.Pressure),
						});
					}}
				/>
			</ActionBarItemGroup>
			<div>
				<Button
					data-cy="createGroup"
					variant="contained"
					color="primary"
					style={{ maxWidth: '100%', minWidth: rem(120) }}
					onClick={() => {
						history.push(
							addRouteNamespace(SENSOR_GROUP_ROUTES.create),
						);
					}}>
					{t('Create Group')}
				</Button>
			</div>
		</ActionBar>
	);
}
